import { GoogleSearchConsoleService } from "@/lib/googleSearchConsoleService";
import { useStore } from "@/store";
import { useCallback } from "react";

export const useGoogleSearchConsoleConnection = () => {
  const { currentUser } = useStore();

  // Connect a new Google Search Console account via OAuth
  const connectNewAccount = useCallback(
    async (redirectUrl?: string) => {
      if (!currentUser?.uid) {
        throw new Error("User not authenticated");
      }

      try {
        const response = await GoogleSearchConsoleService.connect(redirectUrl);

        // Redirect user to Google OAuth
        window.location.href = response.auth_url;
      } catch (err) {
        console.error("GSC connection error:", err);
        throw err;
      }
    },
    [currentUser],
  );

  const getAccounts = useCallback(async () => {
    if (!currentUser?.uid) {
      throw new Error("User not authenticated");
    }
    return GoogleSearchConsoleService.getAllAccounts();
  }, [currentUser]);

  const getSites = useCallback(
    async (accountId: string) => {
      if (!currentUser?.uid) {
        throw new Error("User not authenticated");
      }
      return GoogleSearchConsoleService.getSites(accountId);
    },
    [currentUser],
  );

  const disconnectAccount = useCallback(
    async (accountId: string) => {
      if (!currentUser?.uid) {
        throw new Error("User not authenticated");
      }
      return GoogleSearchConsoleService.disconnect(accountId);
    },
    [currentUser],
  );

  // Read the OAuth callback result from the current URL
  const handleOAuthCallback = useCallback(() => {
    return GoogleSearchConsoleService.parseCallbackParams(window.location.href);
  }, []);

  return {
    connectNewAccount,
    getAccounts,
    getSites,
    disconnectAccount,
    handleOAuthCallback,
  };
};
